export default {
  home: () => import("/apps/web/layouts/home.vue").then(m => m.default || m)
}